import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Search = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M31.71 30.29L21 19.59A11.94 11.94 0 1019.59 21l10.7 10.71a1 1 0 001.41-1.41zM2 11.91a9.91 9.91 0 119.91 9.91A9.92 9.92 0 012 11.91z" })), '0 0 32 32', 'Search');
//# sourceMappingURL=Search.js.map